import { Heading, Stack, Image } from '@chakra-ui/react'
import React from 'react'
import Card from './Card'
import { Card2 } from './Card2'
import Products from './Products'

const Home = () => {
  return (
    <div>
         <div className='StackF' >
           
            <div className="fcontaint">
                <Heading fontSize={'2rem'} style={{
                }}>Light at the end of the
                    <br /> tunnel</Heading>
                   <h3>Fidelity International's Analyst Survey 2023</h3>
                   
                   
                   <button className="hover-btn">Exploe the finding</button>

            </div>
          
            <Image  className='img1' h={['40vh','60vh']} src="https://moneycheck.com/wp-content/uploads/2019/01/fidelity-international-review-2.jpg" alt="" srcset="" />
           
        </div>
<Card/>

<div className="looking">
    <br />    <h1>Looking for another Fidelity site?</h1>
    <div className="hr"><hr /></div>
    <p style={{fontSize:'1rem'}} >Use the <b>Products and Services</b>  menu at the top of this page.</p>
</div>
<Products/>
<Card2/>
    </div>
  )
}

export default Home